export const getInteractions = (chatId) => {
    return {
      type: 'GET_INTERACTIONS',
      payload: { chatId },
    }
  }
  
  export const setInteractions = (chatId, data) => {
    return {
      type: 'SET_INTERACTIONS',
      payload: { chatId, data },
    }
  }
  
  export const apiError = (chatId, error) => {
    return {
      type: 'INTERACTIONS_API_ERROR',
      payload: { chatId, error },
    }
  }
  